import { render } from "./ClientRejectModal.vue?vue&type=template&id=228fe49f&scoped=true"
import script from "./ClientRejectModal.vue?vue&type=script&lang=js"
export * from "./ClientRejectModal.vue?vue&type=script&lang=js"

import "./ClientRejectModal.vue?vue&type=style&index=0&id=228fe49f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228fe49f"]])

export default __exports__